const facilityInfo = {
  name: "SkyLake Resort & Golf Club",
  address: "Chương Mỹ, Hà Nội",
  content:
    "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)."
};

const dataTeeTime = [
  {
    name: "Nguyễn Văn A ádasd",
    vga: 52246,
    money: 2150000,
    hio_100: true,
    hio_200: false,
    package: {
      hotel: false,
      plane_ticket: true,
      food: true,
      car: true,
      hio_100: false,
      hio_200: true
    }
  },
  {
    name: "Nguyễn Văn B",
    vga: 123345,
    money: 2150000,
    hio_100: true,
    hio_200: false,
    package: {
      hotel: false,
      plane_ticket: true,
      food: true,
      car: true,
      hio_100: true,
      hio_200: false
    }
  }
];

const teeTime = {
  time: "06:15",
  date: "02/07/2022",
  name: 1
};

const methodPayment = [
  {
    name: "Thanh toán bằng vBank (Ngân hàng số)",
    icon: "abc",
    value: 1
  },
  {
    name: "Thanh toán chuyển khoản",
    icon: "abc",
    value: 2
  },
  {
    name: "Thanh toán bằng ví điểm thưởng vWallet",
    icon: "def",
    value: 3
  },
  {
    name: "Thanh toán bằng thẻ tín dụng",
    icon: "ghi",
    value: 4
  }
];

const dataQrCode = {
  created_at_timestamp: Date.now(),
  id: 100,
  user_id: 3,
  user_name: "Kelly",
  account_number: "888899988",
  money: 100000,
  id_relation: null,
  description: "Thanh toán tiền đặt sân",
  bank_name: "Ngân hàng TMCP Nam Á",
  bank_napas_id: "NAMAVNVN",
  created_at: "4:42:52,17-12-2021",
  updated_at: "14:42:52,17-12-2021",
  is_hide: 0
};

module.exports = {
  facilityInfo,
  dataTeeTime,
  teeTime,
  methodPayment,
  dataQrCode
};
